import { useMemo, useState } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useNavigate } from "react-router";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import { useGetPIPQuery } from "../../../../api/hrApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import { TableActions } from "../../../Components/Misc/Actions";
import Pagination from "../../../Components/Pagination/Pagination";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import { FilterByStatus } from "./status";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
const PerformanceImprovementPlan = () => {
  const {
    searchText,
    filter,
    setSearchText,
    setFilter,
    date,
    setDate,
    // findSearch,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const user = GetLocalStorage() 
  const { data, isLoading } = useGetPIPQuery({
    PageNumber: currentPage,
    PageSize: pageSize,
    EvaluationStatus: "Fail",
    StartDate: startDate,
    EndDate: endDate,
    GeneralSearch: searchText,
    ApprovalStatus: filter,
    AppraiserId: user.staffId
  });

  const navigate = useNavigate();
  const flattenedKRAs = useMemo(() => {
    if (!data?.responseObject?.pageItems) return [];

    const flattened = [];
    data.responseObject.pageItems.forEach((pageItem) => {
      if (pageItem.krAs && pageItem.krAs.length > 0) {
        pageItem.krAs.forEach((kra) => {
          flattened.push({
            ...kra,
            appraiseeName: pageItem.appraiseeName,
            objectiveTitle: pageItem.objectiveTitle,
            pageItemAppraisalType: pageItem.appraisalType,
          });
        });
      }
    });

    return flattened;
  }, [data]);

  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view`);
    }
  };

  const formatReviewType = (num) => {
    switch (num) {
      case 0:
        return "Self Review";
      case 1:
        return "Line Manager Review";
      case 2:
        return "Peer Review";
      case 3:
        return "Upward Review";
      case 4:
        return "Cross Review";
      default:
        return "Self Review";
    }
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    if (!data?.responseObject?.pageItems) return [];
    return [...data?.responseObject?.pageItems].sort((a, b) => {
      if (!sortColumn) return 0;
      let aValue = a[sortColumn];
      let bValue = b[sortColumn];

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }, [data, sortColumn, sortDirection]);

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return <FaSort className="ml-1" />;
    return sortDirection === "asc" ? (
      <FaSortUp className="ml-1" />
    ) : (
      <FaSortDown className="ml-1" />
    );
  };

  return (
    <PageStyle
      hasBack={true}
      backURL={"/dashboard/hr/HR-Appraisal-Setup"}
      demoTitle={"PERFORMANCE IMPROVEMENT PLAN"}
      hasTopPageDemo
    >
      <form className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          value={searchText}
          text={(searchText) => setSearchText(searchText)}
        />
        <CalendarFilter2
          name="Select Date Range"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          normalDate
        />
        <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Status"}
          filterBy={FilterByStatus}
        />
      </form>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>S/N</th>
              <th
                onClick={() => handleSort("appraiseeName")}
                style={{ cursor: "pointer" }}
              >
                Appraisee Name {renderSortIcon("appraiseeName")}
              </th>
              {/* <th
                onClick={() => handleSort("objectiveTitle")}
                style={{ cursor: "pointer" }}
              >
                Objective Title {renderSortIcon("objectiveTitle")}
              </th> */}
              <th
                onClick={() => handleSort("appraisalType")}
                style={{ cursor: "pointer" }}
              >
                Appraisal Type {renderSortIcon("appraisalType")}
              </th>
              <th
                onClick={() => handleSort("evaluationStatus")}
                style={{ cursor: "pointer" }}
              >
                Evaluation Status {renderSortIcon("evaluationStatus")}
              </th>
              <th
                onClick={() => handleSort("currentStage")}
                style={{ cursor: "pointer" }}
              >
                Current Stage {renderSortIcon("currentStage")}
              </th>
              <th
                onClick={() => handleSort("referenceId")}
                style={{ cursor: "pointer" }}
              >
                Reference Id {renderSortIcon("referenceId")}
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={10} className="text-center">
                  Loading...
                </td>
              </tr>
            )}
            {sortedData &&
              sortedData.length > 0 &&
              sortedData.map((kra, index) => (
                <tr key={kra.id || index}>
                  <td>{index + 1}</td>
                  <td>{kra?.appraiseeName}</td>
                  {/* <td>{kra?.objectiveTitle}</td> */}
                  <td>{formatReviewType(kra?.appraisalType)}</td>
                  <td>
                    <span
                      className={`status ${kra?.evaluationStatus?.toLowerCase()}`}
                    >
                      {kra?.evaluationStatus}
                    </span>
                  </td>
                  <td>{kra?.currentStage || "N/A"}</td>
                  <td>{kra?.referenceId || "N/A"}</td>
                  <td>
                    <TableActions
                      hasChildren={true}
                      url={`${kra.referenceId}/view`}
                    >
                      {[
                        {
                          name: "View Details",
                          action: () => handleView(kra.referenceId),
                        },
                      ]}
                    </TableActions>
                  </td>
                </tr>
              ))}
            {sortedData?.length === 0 && !isLoading && (
              <tr>
                <td colSpan={10} className="text-center">
                  No KRA Records Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Pagination
        last_page={data?.responseObject?.previousPage}
        present_page={data?.responseObject?.currentPage}
        totalRows={data?.responseObject?.totalCount}
        pageSize={data?.responseObject?.pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setCurrentPage(page)}
      />
    </PageStyle>
  );
};

export default PerformanceImprovementPlan;
